import script from "./SchoolSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./SchoolSidebar.vue?vue&type=script&setup=true&lang=js"

import "./SchoolSidebar.vue?vue&type=style&index=0&id=52c2eb04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52c2eb04"]])

export default __exports__